import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
export const STREAMS_BY_INDEX_SET_ID = "streams_by_index_set_id";
const fetchStreamsByIndexSet = async (indexSetId) => {
  const url = qualifyUrl(ApiRoutes.StreamsApiController.byIndexSet(indexSetId).url);
  return fetch("GET", url);
};
const useStreamsByIndexSet = (indexSetId, enabled = true) => {
  const { data, isLoading } = useQuery({
    queryKey: [STREAMS_BY_INDEX_SET_ID],
    queryFn: () => onError(fetchStreamsByIndexSet(indexSetId), (errorThrown) => {
      if (!(errorThrown.status === 404)) {
        UserNotification.error(`Loading streams by index set failed with: ${errorThrown}`);
      }
    }),
    enabled
  });
  return {
    data,
    isLoading
  };
};
export default useStreamsByIndexSet;
